import axiosPost from "./axiosPost";

export const SFUsuarioHotelGet = async (credentials) => {
    const body = {
        service: "SFUsuarioHotelGet",
        params: {},
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
